import { AxiosInstance } from "axios";
import { CreateDiagnosticInput, Diagnostic } from "@/types/diagnostic";
import { CreateDiagnosticResultInput } from "@/types/diagnostic_result";
import { client } from "@/api/client";

export async function fetchDiagnostic(url: string): Promise<Diagnostic> {
  const { data } = await client.get<Diagnostic>(url).catch((error) => {
    throw new Error(error.response.message);
  });
  return data;
}

export interface DiagnosticRepository {
  createDiagnostic(
    diagnostic: CreateDiagnosticInput,
    diagnostic_results: CreateDiagnosticResultInput[]
  ): Promise<Diagnostic>;
}

class DiagnosticRepositoryImpl implements DiagnosticRepository {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createDiagnostic(
    diagnostic: CreateDiagnosticInput,
    diagnostic_results: CreateDiagnosticResultInput[]
  ): Promise<any> {
    const { data } = await this.client
      .post<CreateDiagnosticInput>(`/api/v1/diagnostics`, {
        diagnostic,
        diagnostic_results,
      })
      .catch((error) => {
        throw error.response.status;
      });

    return data;
  }
}

export function newDiagnosticRepository(
  client: AxiosInstance
): DiagnosticRepository {
  return new DiagnosticRepositoryImpl(client);
}
